export enum JobType {
  AlertDigest = 'alertDigest',
  DataInsights = 'dataInsights',
  NewOrganization = 'newOrganization',
}
